import { css } from '@utils/css';

const list = css`
  margin: 0;
  padding: 0;

  list-style-type: none;
`;

export { list };
//# sourceMappingURL=list.js.map
